import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import financ from '../../controller/api/Financ';
import Modal from 'react-bootstrap/Modal';
import User from '../../controller/api/User';
import { Card } from 'react-bootstrap';
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";
import { GetUserContext } from '../../Context/GetUserContext';
import { formatPrice } from '../../controller/views/formats';
import { BsDatabaseFill } from "react-icons/bs";
import './AccountsPayable.css';
import ModalDownNF from '../ModalDownNF';
import Company from '../../controller/api/Company';
import SeachPagination from '../SeachPagination';

const AccountsPayable = () => {
    const { size, dataInicial, dataFinal, setDataInicial, setDataFinal, financeiro, setFinanceiro, axiosConfig, setFetchTimestamp, fetchTimestamp } = useContext(GetUserContext);

    const [datasFinanc, setDatasFinanc] = useState({});
    const [contasPagar, setContasPagar] = useState([]);
    const [show, setShow] = useState(false);
    const [idCompany, setIdCompany] = useState()
    const Financ = new financ();
    const newCompany = new Company();

    useEffect(() => {
        newCompany.getCompany(axiosConfig)
            .then(userDatas => {
                const companyId = userDatas?.data?.Company_ID;
                if (companyId) {
                    setIdCompany(companyId);
                } else {
                    console.warn("Company_ID não encontrado.");
                }
            })
            .catch(err => console.log("Erro ao obter empresa:", err));
    }, [fetchTimestamp]);

    useEffect(() => {
        if (!idCompany) return;

        Financ.getAllOrdersFinanc(idCompany, dataInicial, dataFinal)
            .then(response => {
                setFinanceiro(response);

                const novoFinanceiro = (({ Registro_Financeiros, company, ...rest }) => rest)(response);
                setDatasFinanc(novoFinanceiro);
            })
            .catch(err => console.log("Erro ao buscar financeiro:", err));
    }, [fetchTimestamp, idCompany]);





    useEffect(() => {
        if (datasFinanc) {
            localStorage.setItem('datasFinanc', JSON.stringify(datasFinanc));
        }
    }, [datasFinanc]);

    const handleModalDetails = (e) => {
        setShow(true)
        const updatedContasPagar = e?.Contas_Pagars?.map(item => ({
            ...item,
            pagamento: e?.Forma_de_Pagamento
        }));
        setContasPagar(updatedContasPagar);
    };
    const handleClose = () => setShow(false);

    console.log(financeiro)
    return (
        <div className='area-main-fin'>
            <Card className='card-body-fin'>
                <Card.Body>

                    <SeachPagination currentPage={'finc'} Company_ID={idCompany} />
                    <div>
                        {
                            size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                                (<>
                                    {
                                        financeiro?.Registro_Financeiros?.map((re, index) => (
                                            re?.Contas_Pagars?.length != 0 &&
                                            <React.Fragment key={re?.ID_Registro_Financeiro}>
                                                <div className='area-side-order' >
                                                    <div onClick={() => { handleModalDetails(re) }}
                                                        className='side-order'>
                                                        <span>Data: {re?.Data_Pagamento}</span>
                                                    </div>

                                                    <div onClick={() => { handleModalDetails(re) }}
                                                        className='side-order'>
                                                        <span>N° Pedido: #{re?.ID_Pedido}</span>
                                                    </div>

                                                    <div onClick={() => { handleModalDetails(re) }}
                                                        className='side-order'>
                                                        <span>Empresa: {financeiro?.company?.Corporate_Name}</span>
                                                    </div>

                                                    <div onClick={() => { handleModalDetails(re) }}
                                                        className='side-order'>
                                                        <span>Parcelas: {re?.Parcela}x de R$ {formatPrice(re?.Valor_Parcela)}</span>
                                                    </div>

                                                    <div className='side-order'>
                                                        <div className='d-flex w-100'>
                                                            <div style={{ marginLeft: "5px" }} className=' text-secondary d-flex align-items-center w-50'>Nota Fiscal:</div>
                                                            {
                                                                re?.Pedido?.Cancelado_adm != null ?
                                                                    (<div className='text-secondary'> Cancelado</div>)
                                                                    :
                                                                    (
                                                                        <ModalDownNF id={re?.ID_Pedido} />
                                                                    )
                                                            }
                                                        </div>
                                                    </div>


                                                    <div onClick={() => { handleModalDetails(re) }}
                                                        className='side-order'>
                                                        <span>Parcelas: R$ {formatPrice(re?.Valor_Total)}</span>
                                                    </div>
                                                </div>

                                                <br></br>
                                            </React.Fragment>
                                        ))
                                    }
                                </>)
                                :
                                (
                                    <table className="table table-hover ">
                                        <thead className='header-table'>
                                            <tr>
                                                <th scope="col">Data</th>
                                                <th scope="col">N° Pedido</th>
                                                <th scope="col">Empresa</th>
                                                <th className='text-center' scope="col">Parcelas</th>
                                                <th scope="col">Valor Unid.</th>
                                                <th style={{ textAlign: "center" }} scope="col">NF/Boleto</th>
                                                <th scope="col">Valor Total</th>
                                            </tr>
                                        </thead>

                                        <tbody style={{ cursor: "pointer" }}>
                                            {
                                                financeiro?.Registro_Financeiros?.map((re, index) => (
                                                    re?.Contas_Pagars?.length != 0 &&

                                                    <tr key={index}>
                                                        <td onClick={() => { handleModalDetails(re) }} scope="row">{re?.Data_Pagamento}</td>
                                                        <td onClick={() => { handleModalDetails(re) }}>#{re?.ID_Pedido}</td>
                                                        <td onClick={() => { handleModalDetails(re) }}>{financeiro?.company?.Corporate_Name}</td>
                                                        <td className='text-center' onClick={() => { handleModalDetails(re) }}>{re?.Parcela}x</td>
                                                        <td onClick={() => { handleModalDetails(re) }}>R$ {formatPrice(re?.Valor_Parcela)}</td>
                                                        {
                                                            re?.Pedido?.Cancelado_adm != null ?
                                                                (<td className='fileNF bg-danger-edit'>Cancelado</td>)
                                                                :
                                                                (<td className='fileNF'><ModalDownNF id={re?.ID_Pedido} /></td>)
                                                        }
                                                        <td onClick={() => { handleModalDetails(re) }}>R$ {formatPrice(re?.Valor_Total)}</td>
                                                    </tr>

                                                ))
                                            }
                                        </tbody>
                                    </table>
                                )
                        }

                    </div>
                </Card.Body>
            </Card>


            {
                size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                    (
                        <Modal
                            centered
                            size="lg"
                            fullscreen
                            show={show} onHide={handleClose}>

                            <Modal.Header closeButton>
                                <Modal.Title className='d-flex justify-content-center align-items-center'> <BsDatabaseFill style={{ marginRight: "5px+" }} />Contas a pagar</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>

                                {

                                    contasPagar
                                        ?.sort((a, b) => a.Parcela - b.Parcela)
                                        .map((re, index) => (
                                            <React.Fragment key={index}>
                                                <div className='area-side-order'>
                                                    <div
                                                        className='side-order'>
                                                        <span>Vencimento: {re?.Data_Vencimento}</span>
                                                    </div>

                                                    <div className='side-order'>
                                                        <span>Pagamento: {re?.pagamento?.Pagamento}</span>
                                                    </div>

                                                    <div className='side-order'>
                                                        <span>Parcela: {re?.Parcela}x de R$ {formatPrice(re?.Valor_Parcela)}</span>
                                                    </div>

                                                    <div className='side-order'>
                                                        <span>Valor Total: R$ {formatPrice(re?.Valor_Total)}</span>
                                                    </div>

                                                    <div style={{ borderBottom: "transparent" }}
                                                        className='side-order'>
                                                        <span>Status: {re?.Status_Fatura?.Status}</span>
                                                    </div>
                                                </div>
                                                <br></br>
                                            </React.Fragment>
                                        ))
                                }

                            </Modal.Body>
                        </Modal>
                    )
                    :
                    (
                        <Modal centered size="lg" show={show} onHide={handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title className='d-flex justify-content-center align-items-center'> <BsDatabaseFill style={{ marginRight: "5px+" }} />Contas a pagar</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <table className="table table-hover ">
                                    <thead className='header-table'>
                                        <tr>
                                            <th scope="col">Vencimento</th>

                                            <th scope="col">Pagamento</th>
                                            <th style={{ textAlign: "center" }} scope="col">Parcela</th>
                                            <th scope="col">Valor Unid.</th>
                                            <th scope="col">Valor Total</th>
                                            <th scope="col">Situação</th>
                                        </tr>
                                    </thead>

                                    <tbody style={{ cursor: "pointer" }}>
                                        {

                                            contasPagar
                                                ?.sort((a, b) => a.Parcela - b.Parcela)
                                                .map((re, index) => (
                                                    <tr key={index}>
                                                        <td scope="row">{re?.Data_Vencimento}</td>

                                                        <td scope="row">{re?.pagamento?.Pagamento}</td>
                                                        <td style={{ textAlign: "center" }} scope="row">{re?.Parcela}x</td>
                                                        <td scope="row">R$ {formatPrice(re?.Valor_Parcela)}</td>
                                                        <td scope="row">R$ {formatPrice(re?.Valor_Total)}</td>
                                                        <td scope="row">{re?.Status_Fatura?.Status}</td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </Modal.Body>
                        </Modal >
                    )
            }

        </div >
    )
}

export default AccountsPayable